module.exports = __webpack_public_path__ + "img/credit-score-monitoring-hero-mobile.c031319d.jpg";